import { TFunction } from 'i18next';
import { z } from 'zod';

import { getEmailListSchema } from '@/modules/common/validations';

import { PaymentTerms } from '../types';

/** QuickBooks limits, so a synced client never fails there for length */
const CLIENT_EMAIL_MAX_LENGTH = 100;
const QUICKBOOKS_ADDRESS_MAX_LENGTH = 500;
const ADDRESS_MAX_LENGTH = 1000;

interface ClientInfoSchemaOptions {
  isQuickBooksLinked?: boolean;
}

export const getClientInfoSchema = (
  t: TFunction,
  { isQuickBooksLinked = false }: ClientInfoSchemaOptions = {}
) => {
  const addressMaxLength = isQuickBooksLinked ? QUICKBOOKS_ADDRESS_MAX_LENGTH : ADDRESS_MAX_LENGTH;
  const addressSchema = z
    .string()
    .max(addressMaxLength, t('common:error.maxLength', { max: addressMaxLength }));

  return z.object({
    name: z.string().min(1, t('common:error.required')),
    paymentTerms: z.nativeEnum(PaymentTerms),
    email: getEmailListSchema({
      maxLength: CLIENT_EMAIL_MAX_LENGTH,
      maxLengthMessage: t('common:error.maxLength', { max: CLIENT_EMAIL_MAX_LENGTH }),
      invalidMessage: t('common:error.emailListInvalid'),
    })
      .optional()
      .transform(val => (val === '' ? undefined : val)),
    avatar: z.instanceof(File).optional().nullable(),
    managerId: z.string().optional(),
    billingAddress: addressSchema.optional(),
    shippingAddress: addressSchema.optional(),
  });
};

export type ClientInfoFormData = z.infer<ReturnType<typeof getClientInfoSchema>>;
